import '.l{display:flex;}.ssr-plugin'
import '.i3{background-color:white;}.ssr-plugin'
import '.i4{border-radius:20px;}.ssr-plugin'
import '.b7{border:var(--border-subtle);}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.k{padding:1rem;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.co{align-items:flex-start;}.ssr-plugin'
import '.cg{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.i5{width:6.1875rem;}.ssr-plugin'
import '.i6{height:7.6875rem;}.ssr-plugin'
import '.i7{border-radius:9px;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'

export interface EventProps {
  date: number
  month: string
  category: string
  title: string
  description?: string
  time: string
  location: string
  onClick?: () => void
}

export const Event = ({
  date,
  month,
  category,
  title,
  description = '',
  time,
  location,
  onClick,
}: EventProps) => {
  return (
    <div className="l i3 i4 b7 c k h co"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',}}
    >
      {/* Date Section */}
      <div className="cg k l m aa a1 i5 i6 i7"
      >
        <Text.Large
          style={{
            fontSize: '3.6rem',
            fontWeight: '700',
            color: 'var(--palette-blue-500)',
            lineHeight: '1',
            margin: 0,
          }}
          color="var(--palette-blue-500)"
        >
          {date}
        </Text.Large>
        <Text.ExtraSmall color="var(--palette-blue-500)">
          {String(month).toUpperCase()}
        </Text.ExtraSmall>
      </div>

      {/* Event Details Section */}
      <Column
        style={{
          padding: '0 1rem',
          flex: 1,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          minHeight: '7.6875rem',
        }}
      >
        <div className="n">
          {/* Category */}
          <Text.ExtraSmall
            isBold={true}
            style={{ marginBottom: '0.5rem' }}
            color="var(--brand-primary)"
          >
            {category.toUpperCase()}
          </Text.ExtraSmall>

          {/* Title */}
          <Text.Medium
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              marginBottom: '0.5rem',
            }}
            color="var(--brand-secondary)"
          >
            {title}
          </Text.Medium>

          {/* Description */}
          <Text.Small
            style={{
              lineClamp: 2,
            }}
            color="var(--palette-blue-600)"
          >
            {description}
          </Text.Small>
        </div>
        {/* Time and Location - aligned to bottom */}
        <styled.div>
          <Text.ExtraSmall
            style={{
              marginTop: '0.5rem',
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}
            color="var(--brand-secondary)"
          >
            {time} · {location}
          </Text.ExtraSmall>
        </styled.div>
      </Column>
    </div>
  )
}
